export const defaultLang = "EN";

export const defaultCulture = "en-US";

export const supportedLangs = {
  EN: "English",
  FR: "Français",
};

export const supportedCultures = {
  EN: "en-US",
  FR: "fr-FR",
};
